import { all, put, take } from 'redux-saga/effects';

import { PIPELINE__HIGHLIGHT } from 'PipeRouter';

import create from './create';
import delete_ from './delete';
import select_ from './select';
import update from './update';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPELINE__HIGHLIGHT);

    yield put({ type: cmd, data });
  }
}


export default function* highlight() {
  yield all([
    pipeline(),
    create(),
    delete_(),
    select_(),
    update()
  ]);
}
